import c from "./styles.module.scss";
import Container from "../container";

import babyGMobile from "../../assets/images/banners/baby_g_mobile.png";
import babyGWeb from "../../assets/images/banners/baby_g_web.png";
import gShockMobile from "../../assets/images/banners/g_shock_mobile.avif";
import gShockWeb from "../../assets/images/banners/g_shock_web.webp";
import edificeMobile from "../../assets/images/banners/edifice_mobile.png";
import edificeWeb from "../../assets/images/banners/edifice_web.png";
import proTrekMobile from "../../assets/images/banners/pro_trek_mobile.png";
import proTrekWeb from "../../assets/images/banners/pro_trek_web.png";
import sheenMobile from "../../assets/images/banners/sheen_mobile.png";
import sheenWeb from "../../assets/images/banners/sheen_web.png";
import generalMobile from "../../assets/images/banners/general_mobile.webp";
import generalWeb from "../../assets/images/banners/general_web.webp";
import discountWeb from "../../assets/images/banners/discount_web.webp"
import discountMobile from "../../assets/images/banners/discount_mobile.webp"

import { useState } from "react";
import Button from "../UI/button";
import { NavLink } from "react-router-dom";
import Tag from "../UI/tag";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import { useRef } from "react";
import { useEffect } from "react";


const Slide = ({ data }) => {
  const { theme = "dark", tag, title, text, btn, link, image } = data;

  const content = (
    <>
      {tag && <Tag text={tag} size="small" />}
      {title && <div className={c.title}>{title}</div>}
      {text && <div className={c.text}>{text}</div>}
      {btn && <div className={c.btn}>{btn}</div>}
    </>
  );

  const ImageBlock = (
    <div className={c.image} data-brand={title}>
      <img
        src={image}
        alt={title}
        loading="lazy"
        decoding="async"
      />
    </div>
  );

  const Wrapper = link ? NavLink : "div";
  const wrapperProps = link
    ? { to: link, end: true }
    : {};

  return (
    <Wrapper
      {...wrapperProps}
      className={[c.slide, theme].join(" ")}
    >
      {ImageBlock}
      <div className={c.content}>{content}</div>
    </Wrapper>
  );
};

const MainSlider = () => {
  const prevBtn = useRef(null);
  const nextBtn = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    handler();
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const data = [
     {
      tag: "",
      title: "Скидки",
      btn: <Button text="Подробнее" afterIcon="arrow-right" />,
      link: "/products?discounted=true",
      image: isMobile ? discountMobile : discountWeb,
    },
    {
      tag: "Лимитированное издание",
      title: "G-Shock",
      btn: <Button text="Подробнее" afterIcon="arrow-right" />,
      link: "/products?filters=1123632576%3A1655608949",
      image: isMobile ? gShockMobile : gShockWeb,
    },
    {
      tag: "Новинка",
      title: "General",
      btn: <Button text="Подробнее" afterIcon="arrow-right" />,
      link: "/products?filters=1123632576%3A1673978871",
      image: isMobile ? generalMobile : generalWeb,
    },
    {
      tag: "Новинка",
      title: "Pro-Trek",
      btn: <Button text="Подробнее" afterIcon="arrow-right" />,
      link: "/products?filters=1123632576%3A503817821",
      image: isMobile ? proTrekMobile : proTrekWeb,
    },
    {
      tag: "Новинка",
      title: "Sheen",
      btn: <Button text="Подробнее" afterIcon="arrow-right" />,
      link: "/products?filters=1123632576%3A391419574",
      image: isMobile ? sheenMobile : sheenWeb,
    },
    {
      tag: "Новинка",
      title: "Baby-G",
      btn: <Button text="Подробнее" afterIcon="arrow-right" />,
      link: "/products?filters=1123632576%3A1244322860",
      image: isMobile ? babyGMobile : babyGWeb,
    },
    {
      tag: "Новинка",
      title: "Edifice",
      btn: <Button text="Подробнее" afterIcon="arrow-right" />,
      link: "/products?filters=1123632576%3A919493840",
      image: isMobile ? edificeMobile : edificeWeb,
    },
  ];

  return (
    <section className={c.section}>
      <Container>
        <div className={c.inner}>
          <div className={[c.sliderNav, "dark"].join(" ")}>
            <Button ref={prevBtn} btnStyle="blur" icon="arrow-left" size="smaller" />
            <Button ref={nextBtn} btnStyle="blur" icon="arrow-right" size="smaller" />
          </div>

          <Swiper
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            modules={[Navigation, Autoplay]}
            spaceBetween={40}
            navigation={{ prevEl: prevBtn.current, nextEl: nextBtn.current }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevBtn.current;
              swiper.params.navigation.nextEl = nextBtn.current;
            }}
          >
            {data.map((item, i) => (
              <SwiperSlide key={i}>
                <Slide data={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Container>
    </section>
  );
};

export default MainSlider;